import { r as w, j as k, R as ln } from "./client-BkmPNNjT.mjs.js";
import { a as it, B as Qt, C as fn } from "./button-T1HtNzbf.mjs.js";
import { c as dn } from "./x-BeA-aqru.mjs.js";
const pn = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], mn = dn("chevron-left", pn);
function gn(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Ut(t) {
  return gn(t) || Array.isArray(t);
}
function hn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Dt(t, n) {
  const e = Object.keys(t), i = Object.keys(n);
  if (e.length !== i.length) return !1;
  const c = JSON.stringify(Object.keys(t.breakpoints || {})), r = JSON.stringify(Object.keys(n.breakpoints || {}));
  return c !== r ? !1 : e.every((o) => {
    const u = t[o], s = n[o];
    return typeof u == "function" ? `${u}` == `${s}` : !Ut(u) || !Ut(s) ? u === s : Dt(u, s);
  });
}
function $t(t) {
  return t.concat().sort((n, e) => n.name > e.name ? 1 : -1).map((n) => n.options);
}
function Sn(t, n) {
  if (t.length !== n.length) return !1;
  const e = $t(t), i = $t(n);
  return e.every((c, r) => {
    const o = i[r];
    return Dt(c, o);
  });
}
function Nt(t) {
  return typeof t == "number";
}
function Ot(t) {
  return typeof t == "string";
}
function xt(t) {
  return typeof t == "boolean";
}
function qt(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function A(t) {
  return Math.abs(t);
}
function wt(t) {
  return Math.sign(t);
}
function dt(t, n) {
  return A(t - n);
}
function yn(t, n) {
  if (t === 0 || n === 0 || A(t) <= A(n)) return 0;
  const e = dt(A(t), A(n));
  return A(e / t);
}
function xn(t) {
  return Math.round(t * 100) / 100;
}
function pt(t) {
  return mt(t).map(Number);
}
function Q(t) {
  return t[ht(t)];
}
function ht(t) {
  return Math.max(0, t.length - 1);
}
function Mt(t, n) {
  return n === ht(t);
}
function _t(t, n = 0) {
  return Array.from(Array(t), (e, i) => n + i);
}
function mt(t) {
  return Object.keys(t);
}
function Jt(t, n) {
  return [t, n].reduce((e, i) => (mt(i).forEach((c) => {
    const r = e[c], o = i[c], u = qt(r) && qt(o);
    e[c] = u ? Jt(r, o) : o;
  }), e), {});
}
function Tt(t, n) {
  return typeof n.MouseEvent < "u" && t instanceof n.MouseEvent;
}
function bn(t, n) {
  const e = {
    start: i,
    center: c,
    end: r
  };
  function i() {
    return 0;
  }
  function c(s) {
    return r(s) / 2;
  }
  function r(s) {
    return n - s;
  }
  function o(s, a) {
    return Ot(t) ? e[t](s) : t(n, s, a);
  }
  return {
    measure: o
  };
}
function gt() {
  let t = [];
  function n(c, r, o, u = {
    passive: !0
  }) {
    let s;
    if ("addEventListener" in c)
      c.addEventListener(r, o, u), s = () => c.removeEventListener(r, o, u);
    else {
      const a = c;
      a.addListener(o), s = () => a.removeListener(o);
    }
    return t.push(s), i;
  }
  function e() {
    t = t.filter((c) => c());
  }
  const i = {
    add: n,
    clear: e
  };
  return i;
}
function En(t, n, e, i) {
  const c = gt(), r = 1e3 / 60;
  let o = null, u = 0, s = 0;
  function a() {
    c.add(t, "visibilitychange", () => {
      t.hidden && p();
    });
  }
  function h() {
    y(), c.clear();
  }
  function f(g) {
    if (!s) return;
    o || (o = g, e(), e());
    const l = g - o;
    for (o = g, u += l; u >= r; )
      e(), u -= r;
    const S = u / r;
    i(S), s && (s = n.requestAnimationFrame(f));
  }
  function d() {
    s || (s = n.requestAnimationFrame(f));
  }
  function y() {
    n.cancelAnimationFrame(s), o = null, u = 0, s = 0;
  }
  function p() {
    o = null, u = 0;
  }
  return {
    init: a,
    destroy: h,
    start: d,
    stop: y,
    update: e,
    render: i
  };
}
function vn(t, n) {
  const e = n === "rtl", i = t === "y", c = i ? "y" : "x", r = i ? "x" : "y", o = !i && e ? -1 : 1, u = h(), s = f();
  function a(p) {
    const {
      height: m,
      width: g
    } = p;
    return i ? m : g;
  }
  function h() {
    return i ? "top" : e ? "right" : "left";
  }
  function f() {
    return i ? "bottom" : e ? "left" : "right";
  }
  function d(p) {
    return p * o;
  }
  return {
    scroll: c,
    cross: r,
    startEdge: u,
    endEdge: s,
    measureSize: a,
    direction: d
  };
}
function rt(t = 0, n = 0) {
  const e = A(t - n);
  function i(a) {
    return a < t;
  }
  function c(a) {
    return a > n;
  }
  function r(a) {
    return i(a) || c(a);
  }
  function o(a) {
    return r(a) ? i(a) ? t : n : a;
  }
  function u(a) {
    return e ? a - e * Math.ceil((a - n) / e) : a;
  }
  return {
    length: e,
    max: n,
    min: t,
    constrain: o,
    reachedAny: r,
    reachedMax: c,
    reachedMin: i,
    removeOffset: u
  };
}
function Xt(t, n, e) {
  const {
    constrain: i
  } = rt(0, t), c = t + 1;
  let r = o(n);
  function o(d) {
    return e ? A((c + d) % c) : i(d);
  }
  function u() {
    return r;
  }
  function s(d) {
    return r = o(d), f;
  }
  function a(d) {
    return h().set(u() + d);
  }
  function h() {
    return Xt(t, u(), e);
  }
  const f = {
    get: u,
    set: s,
    add: a,
    clone: h
  };
  return f;
}
function In(t, n, e, i, c, r, o, u, s, a, h, f, d, y, p, m, g, l, S) {
  const {
    cross: b,
    direction: I
  } = t, T = ["INPUT", "SELECT", "TEXTAREA"], L = {
    passive: !1
  }, E = gt(), v = gt(), C = rt(50, 225).constrain(y.measure(20)), P = {
    mouse: 300,
    touch: 400
  }, O = {
    mouse: 500,
    touch: 600
  }, F = p ? 43 : 25;
  let q = !1, D = 0, z = 0, H = !1, G = !1, _ = !1, K = !1;
  function J(x) {
    if (!S) return;
    function N(R) {
      (xt(S) || S(x, R)) && at(R);
    }
    const j = n;
    E.add(j, "dragstart", (R) => R.preventDefault(), L).add(j, "touchmove", () => {
    }, L).add(j, "touchend", () => {
    }).add(j, "touchstart", N).add(j, "mousedown", N).add(j, "touchcancel", B).add(j, "contextmenu", B).add(j, "click", tt, !0);
  }
  function U() {
    E.clear(), v.clear();
  }
  function Y() {
    const x = K ? e : n;
    v.add(x, "touchmove", V, L).add(x, "touchend", B).add(x, "mousemove", V, L).add(x, "mouseup", B);
  }
  function Z(x) {
    const N = x.nodeName || "";
    return T.includes(N);
  }
  function W() {
    return (p ? O : P)[K ? "mouse" : "touch"];
  }
  function ut(x, N) {
    const j = f.add(wt(x) * -1), R = h.byDistance(x, !p).distance;
    return p || A(x) < C ? R : g && N ? R * 0.5 : h.byIndex(j.get(), 0).distance;
  }
  function at(x) {
    const N = Tt(x, i);
    K = N, _ = p && N && !x.buttons && q, q = dt(c.get(), o.get()) >= 2, !(N && x.button !== 0) && (Z(x.target) || (H = !0, r.pointerDown(x), a.useFriction(0).useDuration(0), c.set(o), Y(), D = r.readPoint(x), z = r.readPoint(x, b), d.emit("pointerDown")));
  }
  function V(x) {
    if (!Tt(x, i) && x.touches.length >= 2) return B(x);
    const j = r.readPoint(x), R = r.readPoint(x, b), X = dt(j, D), nt = dt(R, z);
    if (!G && !K && (!x.cancelable || (G = X > nt, !G)))
      return B(x);
    const ot = r.pointerMove(x);
    X > m && (_ = !0), a.useFriction(0.3).useDuration(0.75), u.start(), c.add(I(ot)), x.preventDefault();
  }
  function B(x) {
    const j = h.byDistance(0, !1).index !== f.get(), R = r.pointerUp(x) * W(), X = ut(I(R), j), nt = yn(R, X), ot = F - 10 * nt, et = l + nt / 50;
    G = !1, H = !1, v.clear(), a.useDuration(ot).useFriction(et), s.distance(X, !p), K = !1, d.emit("pointerUp");
  }
  function tt(x) {
    _ && (x.stopPropagation(), x.preventDefault(), _ = !1);
  }
  function $() {
    return H;
  }
  return {
    init: J,
    destroy: U,
    pointerDown: $
  };
}
function Ln(t, n) {
  let i, c;
  function r(f) {
    return f.timeStamp;
  }
  function o(f, d) {
    const p = `client${(d || t.scroll) === "x" ? "X" : "Y"}`;
    return (Tt(f, n) ? f : f.touches[0])[p];
  }
  function u(f) {
    return i = f, c = f, o(f);
  }
  function s(f) {
    const d = o(f) - o(c), y = r(f) - r(i) > 170;
    return c = f, y && (i = f), d;
  }
  function a(f) {
    if (!i || !c) return 0;
    const d = o(c) - o(i), y = r(f) - r(i), p = r(f) - r(c) > 170, m = d / y;
    return y && !p && A(m) > 0.1 ? m : 0;
  }
  return {
    pointerDown: u,
    pointerMove: s,
    pointerUp: a,
    readPoint: o
  };
}
function Cn() {
  function t(e) {
    const {
      offsetTop: i,
      offsetLeft: c,
      offsetWidth: r,
      offsetHeight: o
    } = e;
    return {
      top: i,
      right: c + r,
      bottom: i + o,
      left: c,
      width: r,
      height: o
    };
  }
  return {
    measure: t
  };
}
function On(t) {
  function n(i) {
    return t * (i / 100);
  }
  return {
    measure: n
  };
}
function Tn(t, n, e, i, c, r, o) {
  const u = [t].concat(i);
  let s, a, h = [], f = !1;
  function d(g) {
    return c.measureSize(o.measure(g));
  }
  function y(g) {
    if (!r) return;
    a = d(t), h = i.map(d);
    function l(S) {
      for (const b of S) {
        if (f) return;
        const I = b.target === t, T = i.indexOf(b.target), L = I ? a : h[T], E = d(I ? t : i[T]);
        if (A(E - L) >= 0.5) {
          g.reInit(), n.emit("resize");
          break;
        }
      }
    }
    s = new ResizeObserver((S) => {
      (xt(r) || r(g, S)) && l(S);
    }), e.requestAnimationFrame(() => {
      u.forEach((S) => s.observe(S));
    });
  }
  function p() {
    f = !0, s && s.disconnect();
  }
  return {
    init: y,
    destroy: p
  };
}
function Dn(t, n, e, i, c, r) {
  let o = 0, u = 0, s = c, a = r, h = t.get(), f = 0;
  function d() {
    const L = i.get() - t.get(), E = !s;
    let v = 0;
    return E ? (o = 0, e.set(i), t.set(i), v = L) : (e.set(t), o += L / s, o *= a, h += o, t.add(o), v = h - f), u = wt(v), f = h, T;
  }
  function y() {
    const L = i.get() - n.get();
    return A(L) < 1e-3;
  }
  function p() {
    return s;
  }
  function m() {
    return u;
  }
  function g() {
    return o;
  }
  function l() {
    return b(c);
  }
  function S() {
    return I(r);
  }
  function b(L) {
    return s = L, T;
  }
  function I(L) {
    return a = L, T;
  }
  const T = {
    direction: m,
    duration: p,
    velocity: g,
    seek: d,
    settled: y,
    useBaseFriction: S,
    useBaseDuration: l,
    useFriction: I,
    useDuration: b
  };
  return T;
}
function Nn(t, n, e, i, c) {
  const r = c.measure(10), o = c.measure(50), u = rt(0.1, 0.99);
  let s = !1;
  function a() {
    return !(s || !t.reachedAny(e.get()) || !t.reachedAny(n.get()));
  }
  function h(y) {
    if (!a()) return;
    const p = t.reachedMin(n.get()) ? "min" : "max", m = A(t[p] - n.get()), g = e.get() - n.get(), l = u.constrain(m / o);
    e.subtract(g * l), !y && A(g) < r && (e.set(t.constrain(e.get())), i.useDuration(25).useBaseFriction());
  }
  function f(y) {
    s = !y;
  }
  return {
    shouldConstrain: a,
    constrain: h,
    toggleActive: f
  };
}
function wn(t, n, e, i, c) {
  const r = rt(-n + t, 0), o = f(), u = h(), s = d();
  function a(p, m) {
    return dt(p, m) <= 1;
  }
  function h() {
    const p = o[0], m = Q(o), g = o.lastIndexOf(p), l = o.indexOf(m) + 1;
    return rt(g, l);
  }
  function f() {
    return e.map((p, m) => {
      const {
        min: g,
        max: l
      } = r, S = r.constrain(p), b = !m, I = Mt(e, m);
      return b ? l : I || a(g, S) ? g : a(l, S) ? l : S;
    }).map((p) => parseFloat(p.toFixed(3)));
  }
  function d() {
    if (n <= t + c) return [r.max];
    if (i === "keepSnaps") return o;
    const {
      min: p,
      max: m
    } = u;
    return o.slice(p, m);
  }
  return {
    snapsContained: s,
    scrollContainLimit: u
  };
}
function Mn(t, n, e) {
  const i = n[0], c = e ? i - t : Q(n);
  return {
    limit: rt(c, i)
  };
}
function An(t, n, e, i) {
  const r = n.min + 0.1, o = n.max + 0.1, {
    reachedMin: u,
    reachedMax: s
  } = rt(r, o);
  function a(d) {
    return d === 1 ? s(e.get()) : d === -1 ? u(e.get()) : !1;
  }
  function h(d) {
    if (!a(d)) return;
    const y = t * (d * -1);
    i.forEach((p) => p.add(y));
  }
  return {
    loop: h
  };
}
function Pn(t) {
  const {
    max: n,
    length: e
  } = t;
  function i(r) {
    const o = r - n;
    return e ? o / -e : 0;
  }
  return {
    get: i
  };
}
function kn(t, n, e, i, c) {
  const {
    startEdge: r,
    endEdge: o
  } = t, {
    groupSlides: u
  } = c, s = f().map(n.measure), a = d(), h = y();
  function f() {
    return u(i).map((m) => Q(m)[o] - m[0][r]).map(A);
  }
  function d() {
    return i.map((m) => e[r] - m[r]).map((m) => -A(m));
  }
  function y() {
    return u(a).map((m) => m[0]).map((m, g) => m + s[g]);
  }
  return {
    snaps: a,
    snapsAligned: h
  };
}
function jn(t, n, e, i, c, r) {
  const {
    groupSlides: o
  } = c, {
    min: u,
    max: s
  } = i, a = h();
  function h() {
    const d = o(r), y = !t || n === "keepSnaps";
    return e.length === 1 ? [r] : y ? d : d.slice(u, s).map((p, m, g) => {
      const l = !m, S = Mt(g, m);
      if (l) {
        const b = Q(g[0]) + 1;
        return _t(b);
      }
      if (S) {
        const b = ht(r) - Q(g)[0] + 1;
        return _t(b, Q(g)[0]);
      }
      return p;
    });
  }
  return {
    slideRegistry: a
  };
}
function Fn(t, n, e, i, c) {
  const {
    reachedAny: r,
    removeOffset: o,
    constrain: u
  } = i;
  function s(p) {
    return p.concat().sort((m, g) => A(m) - A(g))[0];
  }
  function a(p) {
    const m = t ? o(p) : u(p), g = n.map((S, b) => ({
      diff: h(S - m, 0),
      index: b
    })).sort((S, b) => A(S.diff) - A(b.diff)), {
      index: l
    } = g[0];
    return {
      index: l,
      distance: m
    };
  }
  function h(p, m) {
    const g = [p, p + e, p - e];
    if (!t) return p;
    if (!m) return s(g);
    const l = g.filter((S) => wt(S) === m);
    return l.length ? s(l) : Q(g) - e;
  }
  function f(p, m) {
    const g = n[p] - c.get(), l = h(g, m);
    return {
      index: p,
      distance: l
    };
  }
  function d(p, m) {
    const g = c.get() + p, {
      index: l,
      distance: S
    } = a(g), b = !t && r(g);
    if (!m || b) return {
      index: l,
      distance: p
    };
    const I = n[l] - S, T = p + h(I, 0);
    return {
      index: l,
      distance: T
    };
  }
  return {
    byDistance: d,
    byIndex: f,
    shortcut: h
  };
}
function zn(t, n, e, i, c, r, o) {
  function u(f) {
    const d = f.distance, y = f.index !== n.get();
    r.add(d), d && (i.duration() ? t.start() : (t.update(), t.render(1), t.update())), y && (e.set(n.get()), n.set(f.index), o.emit("select"));
  }
  function s(f, d) {
    const y = c.byDistance(f, d);
    u(y);
  }
  function a(f, d) {
    const y = n.clone().set(f), p = c.byIndex(y.get(), d);
    u(p);
  }
  return {
    distance: s,
    index: a
  };
}
function Bn(t, n, e, i, c, r, o, u) {
  const s = {
    passive: !0,
    capture: !0
  };
  let a = 0;
  function h(y) {
    if (!u) return;
    function p(m) {
      if ((/* @__PURE__ */ new Date()).getTime() - a > 10) return;
      o.emit("slideFocusStart"), t.scrollLeft = 0;
      const S = e.findIndex((b) => b.includes(m));
      Nt(S) && (c.useDuration(0), i.index(S, 0), o.emit("slideFocus"));
    }
    r.add(document, "keydown", f, !1), n.forEach((m, g) => {
      r.add(m, "focus", (l) => {
        (xt(u) || u(y, l)) && p(g);
      }, s);
    });
  }
  function f(y) {
    y.code === "Tab" && (a = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: h
  };
}
function ft(t) {
  let n = t;
  function e() {
    return n;
  }
  function i(s) {
    n = o(s);
  }
  function c(s) {
    n += o(s);
  }
  function r(s) {
    n -= o(s);
  }
  function o(s) {
    return Nt(s) ? s : s.get();
  }
  return {
    get: e,
    set: i,
    add: c,
    subtract: r
  };
}
function Yt(t, n) {
  const e = t.scroll === "x" ? o : u, i = n.style;
  let c = null, r = !1;
  function o(d) {
    return `translate3d(${d}px,0px,0px)`;
  }
  function u(d) {
    return `translate3d(0px,${d}px,0px)`;
  }
  function s(d) {
    if (r) return;
    const y = xn(t.direction(d));
    y !== c && (i.transform = e(y), c = y);
  }
  function a(d) {
    r = !d;
  }
  function h() {
    r || (i.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: h,
    to: s,
    toggleActive: a
  };
}
function Rn(t, n, e, i, c, r, o, u, s) {
  const h = pt(c), f = pt(c).reverse(), d = l().concat(S());
  function y(E, v) {
    return E.reduce((C, P) => C - c[P], v);
  }
  function p(E, v) {
    return E.reduce((C, P) => y(C, v) > 0 ? C.concat([P]) : C, []);
  }
  function m(E) {
    return r.map((v, C) => ({
      start: v - i[C] + 0.5 + E,
      end: v + n - 0.5 + E
    }));
  }
  function g(E, v, C) {
    const P = m(v);
    return E.map((O) => {
      const F = C ? 0 : -e, q = C ? e : 0, D = C ? "end" : "start", z = P[O][D];
      return {
        index: O,
        loopPoint: z,
        slideLocation: ft(-1),
        translate: Yt(t, s[O]),
        target: () => u.get() > z ? F : q
      };
    });
  }
  function l() {
    const E = o[0], v = p(f, E);
    return g(v, e, !1);
  }
  function S() {
    const E = n - o[0] - 1, v = p(h, E);
    return g(v, -e, !0);
  }
  function b() {
    return d.every(({
      index: E
    }) => {
      const v = h.filter((C) => C !== E);
      return y(v, n) <= 0.1;
    });
  }
  function I() {
    d.forEach((E) => {
      const {
        target: v,
        translate: C,
        slideLocation: P
      } = E, O = v();
      O !== P.get() && (C.to(O), P.set(O));
    });
  }
  function T() {
    d.forEach((E) => E.translate.clear());
  }
  return {
    canLoop: b,
    clear: T,
    loop: I,
    loopPoints: d
  };
}
function Vn(t, n, e) {
  let i, c = !1;
  function r(s) {
    if (!e) return;
    function a(h) {
      for (const f of h)
        if (f.type === "childList") {
          s.reInit(), n.emit("slidesChanged");
          break;
        }
    }
    i = new MutationObserver((h) => {
      c || (xt(e) || e(s, h)) && a(h);
    }), i.observe(t, {
      childList: !0
    });
  }
  function o() {
    i && i.disconnect(), c = !0;
  }
  return {
    init: r,
    destroy: o
  };
}
function Hn(t, n, e, i) {
  const c = {};
  let r = null, o = null, u, s = !1;
  function a() {
    u = new IntersectionObserver((p) => {
      s || (p.forEach((m) => {
        const g = n.indexOf(m.target);
        c[g] = m;
      }), r = null, o = null, e.emit("slidesInView"));
    }, {
      root: t.parentElement,
      threshold: i
    }), n.forEach((p) => u.observe(p));
  }
  function h() {
    u && u.disconnect(), s = !0;
  }
  function f(p) {
    return mt(c).reduce((m, g) => {
      const l = parseInt(g), {
        isIntersecting: S
      } = c[l];
      return (p && S || !p && !S) && m.push(l), m;
    }, []);
  }
  function d(p = !0) {
    if (p && r) return r;
    if (!p && o) return o;
    const m = f(p);
    return p && (r = m), p || (o = m), m;
  }
  return {
    init: a,
    destroy: h,
    get: d
  };
}
function Gn(t, n, e, i, c, r) {
  const {
    measureSize: o,
    startEdge: u,
    endEdge: s
  } = t, a = e[0] && c, h = p(), f = m(), d = e.map(o), y = g();
  function p() {
    if (!a) return 0;
    const S = e[0];
    return A(n[u] - S[u]);
  }
  function m() {
    if (!a) return 0;
    const S = r.getComputedStyle(Q(i));
    return parseFloat(S.getPropertyValue(`margin-${s}`));
  }
  function g() {
    return e.map((S, b, I) => {
      const T = !b, L = Mt(I, b);
      return T ? d[b] + h : L ? d[b] + f : I[b + 1][u] - S[u];
    }).map(A);
  }
  return {
    slideSizes: d,
    slideSizesWithGaps: y,
    startGap: h,
    endGap: f
  };
}
function Un(t, n, e, i, c, r, o, u, s) {
  const {
    startEdge: a,
    endEdge: h,
    direction: f
  } = t, d = Nt(e);
  function y(l, S) {
    return pt(l).filter((b) => b % S === 0).map((b) => l.slice(b, b + S));
  }
  function p(l) {
    return l.length ? pt(l).reduce((S, b, I) => {
      const T = Q(S) || 0, L = T === 0, E = b === ht(l), v = c[a] - r[T][a], C = c[a] - r[b][h], P = !i && L ? f(o) : 0, O = !i && E ? f(u) : 0, F = A(C - O - (v + P));
      return I && F > n + s && S.push(b), E && S.push(l.length), S;
    }, []).map((S, b, I) => {
      const T = Math.max(I[b - 1] || 0);
      return l.slice(T, S);
    }) : [];
  }
  function m(l) {
    return d ? y(l, e) : p(l);
  }
  return {
    groupSlides: m
  };
}
function $n(t, n, e, i, c, r, o) {
  const {
    align: u,
    axis: s,
    direction: a,
    startIndex: h,
    loop: f,
    duration: d,
    dragFree: y,
    dragThreshold: p,
    inViewThreshold: m,
    slidesToScroll: g,
    skipSnaps: l,
    containScroll: S,
    watchResize: b,
    watchSlides: I,
    watchDrag: T,
    watchFocus: L
  } = r, E = 2, v = Cn(), C = v.measure(n), P = e.map(v.measure), O = vn(s, a), F = O.measureSize(C), q = On(F), D = bn(u, F), z = !f && !!S, H = f || !!S, {
    slideSizes: G,
    slideSizesWithGaps: _,
    startGap: K,
    endGap: J
  } = Gn(O, C, P, e, H, c), U = Un(O, F, g, f, C, P, K, J, E), {
    snaps: Y,
    snapsAligned: Z
  } = kn(O, D, C, P, U), W = -Q(Y) + Q(_), {
    snapsContained: ut,
    scrollContainLimit: at
  } = wn(F, W, Z, S, E), V = z ? ut : Z, {
    limit: B
  } = Mn(W, V, f), tt = Xt(ht(V), h, f), $ = tt.clone(), M = pt(e), x = ({
    dragHandler: ct,
    scrollBody: Lt,
    scrollBounds: Ct,
    options: {
      loop: St
    }
  }) => {
    St || Ct.constrain(ct.pointerDown()), Lt.seek();
  }, N = ({
    scrollBody: ct,
    translate: Lt,
    location: Ct,
    offsetLocation: St,
    previousLocation: nn,
    scrollLooper: en,
    slideLooper: on,
    dragHandler: sn,
    animation: rn,
    eventHandler: zt,
    scrollBounds: cn,
    options: {
      loop: Bt
    }
  }, Rt) => {
    const Vt = ct.settled(), un = !cn.shouldConstrain(), Ht = Bt ? Vt : Vt && un, Gt = Ht && !sn.pointerDown();
    Gt && rn.stop();
    const an = Ct.get() * Rt + nn.get() * (1 - Rt);
    St.set(an), Bt && (en.loop(ct.direction()), on.loop()), Lt.to(St.get()), Gt && zt.emit("settle"), Ht || zt.emit("scroll");
  }, j = En(i, c, () => x(It), (ct) => N(It, ct)), R = 0.68, X = V[tt.get()], nt = ft(X), ot = ft(X), et = ft(X), st = ft(X), lt = Dn(nt, et, ot, st, d, R), Et = Fn(f, V, W, B, st), vt = zn(j, tt, $, lt, Et, st, o), kt = Pn(B), jt = gt(), Wt = Hn(n, e, o, m), {
    slideRegistry: Ft
  } = jn(z, S, V, at, U, M), tn = Bn(t, e, Ft, vt, lt, jt, o, L), It = {
    ownerDocument: i,
    ownerWindow: c,
    eventHandler: o,
    containerRect: C,
    slideRects: P,
    animation: j,
    axis: O,
    dragHandler: In(O, t, i, c, st, Ln(O, c), nt, j, vt, lt, Et, tt, o, q, y, p, l, R, T),
    eventStore: jt,
    percentOfView: q,
    index: tt,
    indexPrevious: $,
    limit: B,
    location: nt,
    offsetLocation: et,
    previousLocation: ot,
    options: r,
    resizeHandler: Tn(n, o, c, e, O, b, v),
    scrollBody: lt,
    scrollBounds: Nn(B, et, st, lt, q),
    scrollLooper: An(W, B, et, [nt, et, ot, st]),
    scrollProgress: kt,
    scrollSnapList: V.map(kt.get),
    scrollSnaps: V,
    scrollTarget: Et,
    scrollTo: vt,
    slideLooper: Rn(O, F, W, G, _, Y, V, et, e),
    slideFocus: tn,
    slidesHandler: Vn(n, o, I),
    slidesInView: Wt,
    slideIndexes: M,
    slideRegistry: Ft,
    slidesToScroll: U,
    target: st,
    translate: Yt(O, n)
  };
  return It;
}
function qn() {
  let t = {}, n;
  function e(a) {
    n = a;
  }
  function i(a) {
    return t[a] || [];
  }
  function c(a) {
    return i(a).forEach((h) => h(n, a)), s;
  }
  function r(a, h) {
    return t[a] = i(a).concat([h]), s;
  }
  function o(a, h) {
    return t[a] = i(a).filter((f) => f !== h), s;
  }
  function u() {
    t = {};
  }
  const s = {
    init: e,
    emit: c,
    off: o,
    on: r,
    clear: u
  };
  return s;
}
const _n = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Kn(t) {
  function n(r, o) {
    return Jt(r, o || {});
  }
  function e(r) {
    const o = r.breakpoints || {}, u = mt(o).filter((s) => t.matchMedia(s).matches).map((s) => o[s]).reduce((s, a) => n(s, a), {});
    return n(r, u);
  }
  function i(r) {
    return r.map((o) => mt(o.breakpoints || {})).reduce((o, u) => o.concat(u), []).map(t.matchMedia);
  }
  return {
    mergeOptions: n,
    optionsAtMedia: e,
    optionsMediaQueries: i
  };
}
function Qn(t) {
  let n = [];
  function e(r, o) {
    return n = o.filter(({
      options: u
    }) => t.optionsAtMedia(u).active !== !1), n.forEach((u) => u.init(r, t)), o.reduce((u, s) => Object.assign(u, {
      [s.name]: s
    }), {});
  }
  function i() {
    n = n.filter((r) => r.destroy());
  }
  return {
    init: e,
    destroy: i
  };
}
function yt(t, n, e) {
  const i = t.ownerDocument, c = i.defaultView, r = Kn(c), o = Qn(r), u = gt(), s = qn(), {
    mergeOptions: a,
    optionsAtMedia: h,
    optionsMediaQueries: f
  } = r, {
    on: d,
    off: y,
    emit: p
  } = s, m = O;
  let g = !1, l, S = a(_n, yt.globalOptions), b = a(S), I = [], T, L, E;
  function v() {
    const {
      container: M,
      slides: x
    } = b;
    L = (Ot(M) ? t.querySelector(M) : M) || t.children[0];
    const j = Ot(x) ? L.querySelectorAll(x) : x;
    E = [].slice.call(j || L.children);
  }
  function C(M) {
    const x = $n(t, L, E, i, c, M, s);
    if (M.loop && !x.slideLooper.canLoop()) {
      const N = Object.assign({}, M, {
        loop: !1
      });
      return C(N);
    }
    return x;
  }
  function P(M, x) {
    g || (S = a(S, M), b = h(S), I = x || I, v(), l = C(b), f([S, ...I.map(({
      options: N
    }) => N)]).forEach((N) => u.add(N, "change", O)), b.active && (l.translate.to(l.location.get()), l.animation.init(), l.slidesInView.init(), l.slideFocus.init($), l.eventHandler.init($), l.resizeHandler.init($), l.slidesHandler.init($), l.options.loop && l.slideLooper.loop(), L.offsetParent && E.length && l.dragHandler.init($), T = o.init($, I)));
  }
  function O(M, x) {
    const N = U();
    F(), P(a({
      startIndex: N
    }, M), x), s.emit("reInit");
  }
  function F() {
    l.dragHandler.destroy(), l.eventStore.clear(), l.translate.clear(), l.slideLooper.clear(), l.resizeHandler.destroy(), l.slidesHandler.destroy(), l.slidesInView.destroy(), l.animation.destroy(), o.destroy(), u.clear();
  }
  function q() {
    g || (g = !0, u.clear(), F(), s.emit("destroy"), s.clear());
  }
  function D(M, x, N) {
    !b.active || g || (l.scrollBody.useBaseFriction().useDuration(x === !0 ? 0 : b.duration), l.scrollTo.index(M, N || 0));
  }
  function z(M) {
    const x = l.index.add(1).get();
    D(x, M, -1);
  }
  function H(M) {
    const x = l.index.add(-1).get();
    D(x, M, 1);
  }
  function G() {
    return l.index.add(1).get() !== U();
  }
  function _() {
    return l.index.add(-1).get() !== U();
  }
  function K() {
    return l.scrollSnapList;
  }
  function J() {
    return l.scrollProgress.get(l.offsetLocation.get());
  }
  function U() {
    return l.index.get();
  }
  function Y() {
    return l.indexPrevious.get();
  }
  function Z() {
    return l.slidesInView.get();
  }
  function W() {
    return l.slidesInView.get(!1);
  }
  function ut() {
    return T;
  }
  function at() {
    return l;
  }
  function V() {
    return t;
  }
  function B() {
    return L;
  }
  function tt() {
    return E;
  }
  const $ = {
    canScrollNext: G,
    canScrollPrev: _,
    containerNode: B,
    internalEngine: at,
    destroy: q,
    off: y,
    on: d,
    emit: p,
    plugins: ut,
    previousScrollSnap: Y,
    reInit: m,
    rootNode: V,
    scrollNext: z,
    scrollPrev: H,
    scrollProgress: J,
    scrollSnapList: K,
    scrollTo: D,
    selectedScrollSnap: U,
    slideNodes: tt,
    slidesInView: Z,
    slidesNotInView: W
  };
  return P(n, e), setTimeout(() => s.emit("init"), 0), $;
}
yt.globalOptions = void 0;
function At(t = {}, n = []) {
  const e = w.useRef(t), i = w.useRef(n), [c, r] = w.useState(), [o, u] = w.useState(), s = w.useCallback(() => {
    c && c.reInit(e.current, i.current);
  }, [c]);
  return w.useEffect(() => {
    Dt(e.current, t) || (e.current = t, s());
  }, [t, s]), w.useEffect(() => {
    Sn(i.current, n) || (i.current = n, s());
  }, [n, s]), w.useEffect(() => {
    if (hn() && o) {
      yt.globalOptions = At.globalOptions;
      const a = yt(o, e.current, i.current);
      return r(a), () => a.destroy();
    } else
      r(void 0);
  }, [o, r]), [u, c];
}
At.globalOptions = void 0;
const Zt = w.createContext(null);
function bt() {
  const t = w.useContext(Zt);
  if (!t)
    throw new Error("useCarousel must be used within a <Carousel />");
  return t;
}
const Jn = (t) => {
  const [n, e] = w.useState(0), [i, c] = w.useState([]), r = w.useCallback((s) => {
    t && t.scrollTo(s);
  }, [t]), o = w.useCallback((s) => {
    c(s.scrollSnapList());
  }, []), u = w.useCallback((s) => {
    e(s.selectedScrollSnap());
  }, []);
  return w.useEffect(() => {
    t && (o(t), u(t), t.on("reInit", o).on("reInit", u).on("select", u));
  }, [t, o, u]), {
    selectedIndex: n,
    scrollSnaps: i,
    onDotButtonClick: r
  };
};
function Xn({
  orientation: t = "horizontal",
  opts: n,
  setApi: e,
  plugins: i,
  className: c,
  children: r,
  ...o
}) {
  const [u, s] = At({
    ...n,
    axis: t === "horizontal" ? "x" : "y"
  }, i), [a, h] = w.useState(!1), [f, d] = w.useState(!1), y = w.useCallback((l) => {
    l && (h(l.canScrollPrev()), d(l.canScrollNext()));
  }, []), p = w.useCallback(() => {
    s?.scrollPrev();
  }, [s]), m = w.useCallback(() => {
    s?.scrollNext();
  }, [s]), g = w.useCallback((l) => {
    l.key === "ArrowLeft" ? (l.preventDefault(), p()) : l.key === "ArrowRight" && (l.preventDefault(), m());
  }, [p, m]);
  return w.useEffect(() => {
    !s || !e || e(s);
  }, [s, e]), w.useEffect(() => {
    if (s)
      return y(s), s.on("reInit", y), s.on("select", y), () => {
        s?.off("select", y);
      };
  }, [s, y]), /* @__PURE__ */ k.jsx(Zt.Provider, {
    value: {
      carouselRef: u,
      api: s,
      opts: n,
      orientation: t || (n?.axis === "y" ? "vertical" : "horizontal"),
      scrollPrev: p,
      scrollNext: m,
      canScrollPrev: a,
      canScrollNext: f
    },
    children: /* @__PURE__ */ k.jsx("div", {
      onKeyDownCapture: g,
      className: it("relative", c),
      role: "region",
      "aria-roledescription": "carousel",
      "data-slot": "carousel",
      ...o,
      children: r
    })
  });
}
function Yn({
  className: t,
  ...n
}) {
  const {
    carouselRef: e,
    orientation: i
  } = bt();
  return /* @__PURE__ */ k.jsx("div", {
    ref: e,
    className: "overflow-hidden",
    "data-slot": "carousel-content",
    children: /* @__PURE__ */ k.jsx("div", {
      className: it("flex", i === "horizontal" ? "-ml-4" : "-mt-4 flex-col", t),
      ...n
    })
  });
}
function Kt({
  className: t,
  ...n
}) {
  const {
    orientation: e
  } = bt();
  return /* @__PURE__ */ k.jsx("div", {
    role: "group",
    "aria-roledescription": "slide",
    "data-slot": "carousel-item",
    className: it("min-w-0 shrink-0 grow-0 basis-full", e === "horizontal" ? "pl-4" : "pt-4", t),
    ...n
  });
}
function Zn({
  className: t,
  variant: n = "outline",
  size: e = "icon",
  ...i
}) {
  const {
    orientation: c,
    scrollPrev: r,
    canScrollPrev: o
  } = bt();
  return /* @__PURE__ */ k.jsxs(Qt, {
    "data-slot": "carousel-previous",
    variant: n,
    size: e,
    className: it("absolute size-9 rounded-full shadow-custom", c === "horizontal" ? "top-1/2 -left-1 md:-left-8 -translate-y-1/2" : "-top-8 left-1/2 -translate-x-1/2 rotate-90", t),
    disabled: !o,
    onClick: r,
    ...i,
    children: [/* @__PURE__ */ k.jsx(mn, {
      className: "stroke-3 size-5"
    }), /* @__PURE__ */ k.jsx("span", {
      className: "sr-only",
      children: "Previous slide"
    })]
  });
}
function Wn({
  className: t,
  variant: n = "outline",
  size: e = "icon",
  ...i
}) {
  const {
    orientation: c,
    scrollNext: r,
    canScrollNext: o
  } = bt();
  return /* @__PURE__ */ k.jsxs(Qt, {
    "data-slot": "carousel-next",
    variant: n,
    size: e,
    className: it("absolute size-9 rounded-full shadow-custom", c === "horizontal" ? "top-1/2 -right-1 md:-right-8 -translate-y-1/2" : "-bottom-8 left-1/2 -translate-x-1/2 rotate-90", t),
    disabled: !o,
    onClick: r,
    ...i,
    children: [/* @__PURE__ */ k.jsx(fn, {
      className: "stroke-3 size-5"
    }), /* @__PURE__ */ k.jsx("span", {
      className: "sr-only",
      children: "Next slide"
    })]
  });
}
function te({
  className: t,
  ...n
}) {
  return /* @__PURE__ */ k.jsx("div", {
    className: it("flex justify-center items-center gap-1", t),
    ...n
  });
}
function ne({
  className: t,
  isSelected: n,
  ...e
}) {
  return /* @__PURE__ */ k.jsx("button", {
    type: "button",
    className: it("border bg-gray-200 size-2 aria-selected:size-3 aria-selected:bg-primary rounded-full", t),
    "aria-selected": n,
    ...e
  });
}
const ee = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function oe(t, n) {
  const e = t.scrollSnapList();
  return typeof n == "number" ? e.map(() => n) : n(e, t);
}
function se(t, n) {
  const e = t.rootNode();
  return n && n(e) || e;
}
function Pt(t = {}) {
  let n, e, i, c, r = null, o = 0, u = !1, s = !1, a = !1, h = !1;
  function f(D, z) {
    e = D;
    const {
      mergeOptions: H,
      optionsAtMedia: G
    } = z, _ = H(ee, Pt.globalOptions), K = H(_, t);
    if (n = G(K), e.scrollSnapList().length <= 1) return;
    h = n.jump, i = !1, c = oe(e, n.delay);
    const {
      eventStore: J,
      ownerDocument: U
    } = e.internalEngine(), Y = !!e.internalEngine().options.watchDrag, Z = se(e, n.rootNode);
    J.add(U, "visibilitychange", l), Y && e.on("pointerDown", b), Y && !n.stopOnInteraction && e.on("pointerUp", I), n.stopOnMouseEnter && J.add(Z, "mouseenter", T), n.stopOnMouseEnter && !n.stopOnInteraction && J.add(Z, "mouseleave", L), n.stopOnFocusIn && e.on("slideFocusStart", g), n.stopOnFocusIn && !n.stopOnInteraction && J.add(e.containerNode(), "focusout", m), n.playOnInit && m();
  }
  function d() {
    e.off("pointerDown", b).off("pointerUp", I).off("slideFocusStart", g), g(), i = !0, u = !1;
  }
  function y() {
    const {
      ownerWindow: D
    } = e.internalEngine();
    D.clearTimeout(o), o = D.setTimeout(O, c[e.selectedScrollSnap()]), r = (/* @__PURE__ */ new Date()).getTime(), e.emit("autoplay:timerset");
  }
  function p() {
    const {
      ownerWindow: D
    } = e.internalEngine();
    D.clearTimeout(o), o = 0, r = null, e.emit("autoplay:timerstopped");
  }
  function m() {
    if (!i) {
      if (S()) {
        a = !0;
        return;
      }
      u || e.emit("autoplay:play"), y(), u = !0;
    }
  }
  function g() {
    i || (u && e.emit("autoplay:stop"), p(), u = !1);
  }
  function l() {
    if (S())
      return a = u, g();
    a && m();
  }
  function S() {
    const {
      ownerDocument: D
    } = e.internalEngine();
    return D.visibilityState === "hidden";
  }
  function b() {
    s || g();
  }
  function I() {
    s || m();
  }
  function T() {
    s = !0, g();
  }
  function L() {
    s = !1, m();
  }
  function E(D) {
    typeof D < "u" && (h = D), m();
  }
  function v() {
    u && g();
  }
  function C() {
    u && m();
  }
  function P() {
    return u;
  }
  function O() {
    const {
      index: D
    } = e.internalEngine(), z = D.clone().add(1).get(), H = e.scrollSnapList().length - 1, G = n.stopOnLastSnap && z === H;
    if (e.canScrollNext() ? e.scrollNext(h) : e.scrollTo(0, h), e.emit("autoplay:select"), G) return g();
    m();
  }
  function F() {
    if (!r) return null;
    const D = c[e.selectedScrollSnap()], z = (/* @__PURE__ */ new Date()).getTime() - r;
    return D - z;
  }
  return {
    name: "autoplay",
    options: t,
    init: f,
    destroy: d,
    play: E,
    stop: v,
    reset: C,
    isPlaying: P,
    timeUntilNext: F
  };
}
Pt.globalOptions = void 0;
const ue = ({
  autoplay: t,
  children: n,
  css: e = {},
  options: i
}) => {
  const [c, r] = w.useState(void 0), [o, u] = w.useMemo(() => {
    const f = [], d = {
      align: "start",
      slidesToScroll: "auto",
      dragFree: !0,
      ...i
    };
    return t && f.push(Pt({
      delay: t
    })), [d, f];
  }, [t]), {
    selectedIndex: s,
    scrollSnaps: a,
    onDotButtonClick: h
  } = Jn(c);
  return /* @__PURE__ */ k.jsxs(Xn, {
    opts: o,
    className: e.root,
    plugins: u,
    setApi: r,
    children: [/* @__PURE__ */ k.jsx(Yn, {
      className: e.content,
      children: n instanceof NodeList ? Array.from(n).map((f, d) => /* @__PURE__ */ k.jsx(Kt, {
        className: e.item,
        dangerouslySetInnerHTML: {
          __html: f.innerHTML
        }
      }, d)) : ln.Children.map(n, (f, d) => /* @__PURE__ */ k.jsx(Kt, {
        className: e.item,
        children: f
      }, d))
    }), /* @__PURE__ */ k.jsx(Zn, {
      className: e.prevBtn
    }), /* @__PURE__ */ k.jsx(Wn, {
      className: e.nextBtn
    }), a.length > 1 && /* @__PURE__ */ k.jsx(te, {
      className: e.dots,
      children: a.map((f, d) => /* @__PURE__ */ k.jsx(ne, {
        isSelected: s === d,
        className: e.dot,
        onClick: () => h(d)
      }, d))
    })]
  });
};
export {
  ue as ManagedCarousel
};
